import React from 'react';
import { Link } from 'react-router-dom';
import { Level } from 'rbx';
import styled from 'styled-components';

import { Heading } from '../../../components/elements';

const Wrapper = styled.div`
  padding: 1rem 1rem;
  border-bottom: 1px solid #f6f6f6;
`;

const Header = () => (
  <Wrapper>
    <Level>
      <Level.Item align="left">
        <Heading>Manage Menu Deals</Heading>
      </Level.Item>
      <Level.Item align="right">
        <Link to="/manage-combo-deal" className="button is-primary">
          <span className="has-text-weight-semibold">Add a New Deal</span>
        </Link>
      </Level.Item>
    </Level>
  </Wrapper>
);

export default Header;
